module.exports = __webpack_public_path__ + "static/img/data4-img.119dfe3a.png";